import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

/*
 * The Breadcrumb Handler is responsible to parse the current url to a more representative representation.
 * It is listening to changes in the router and parses something like /onboarding/telekom/step1 into
 * Onboarding > Telekom > Step1.
 * This will be utilized by the applications header mainly.
 */
@Injectable({
  providedIn: 'root',
})
export class BreadcrumbHandler {
  public breadcrumb = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  initialize() {
    this.listenToRouteChanges();
  }

  private listenToRouteChanges() {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe((r) => {
      this.generateBreadcrumb();
    });
  }

  private generateBreadcrumb() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      let currentRoute = this.route;

      // We need to get the deepest child here to know where we are. Yes this is how angular wants it to be done oO
      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      }

      this.breadcrumb = currentRoute.snapshot.data['breadcrumb'];
    });
  }
}
